import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    payload: {},
    loading: false,
    helpers: {},
    response: {
        has: false,
        type: '',
        message: ''
    },
    errors: {
        missing: {},
        api: {}
    },
    blocks: {},
    bar: {
        hide: false,
        active: false,
        block: false
    },
    reset: false,
    update: false,
    trigger: false,
    searchData: {}
};

export default {
    state,
    getters,
    mutations,
    actions
};